import { handleError } from "@/utils/error";
import { useNavigate } from "@tanstack/react-router";
import { useDeleteFamily } from "creso-core/hooks";
import { FamilyDetail } from "creso-core/types";
import { Trash2Icon } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogTrigger,
} from "web-design-system";

export function DeleteFamily({ family }: { family: FamilyDetail }) {
  const { mutateAsync: deleteFamily } = useDeleteFamily(family.id);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleDelete = async () => {
    try {
      await deleteFamily();
      toast.success("Family deleted successfully");
      navigate({ to: "/clients/families" });
    } catch (error) {
      handleError(error, "Failed to delete family");
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger className="hover:bg-muted w-full text-destructive flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground [&_svg]:size-4 [&_svg]:shrink-0">
        <Trash2Icon />
        Delete
      </DialogTrigger>
      <DialogContent>
        <span className="text-lg font-semibold">
          Are you sure you want to delete this family?
        </span>
        <p className="text-sm mt-auto text-muted-foreground">
          This action cannot be undone.
        </p>
        <DialogFooter>
          <Button onClick={handleDelete} variant="outline">
            Yes, Delete
          </Button>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
